import React, { useEffect, useState } from "react";
import {
    Container, Row, Col, Button, Spinner, Modal, ModalBody, ModalHeader, ModalFooter, Input, Label
} from "reactstrap";
import Handler from "../Helpers/Handler";
import { getCookie, reloadWindowToPath } from "../Helpers/Utils";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CartImg from '../Assets/images/empty-cart.svg'

const Cart = () => {
    const sessionId = getCookie("sessionToken");
    const navigate = useNavigate();
    const slug = getCookie('slug')
    const [loading, setLoading] = useState(false);
    const [cartData, setCartData] = useState({ items: [], total: 0 });
    const [updating, setUpdating] = useState(null);

    const [checkoutOpen, setCheckoutOpen] = useState(false);

    // ORDER TYPE
    const [orderType, setOrderType] = useState("outdoor");

    // Checkout Fields
    const [doorNo, setDoorNo] = useState("");
    const [address, setAddress] = useState("");
    const [pincode, setPincode] = useState("");
    const [city, setCity] = useState("");
    const [district, setDistrict] = useState("");

    const toggleCheckout = () => setCheckoutOpen(!checkoutOpen);

    const loadCart = async () => {
        if (!sessionId) return;

        setLoading(true);

        try {
            const response = await Handler({
                method: "get",
                url: `/cart/get.php?session_id=${sessionId}`,
            });

            if (response?.success) {
                setCartData(response.cart);
            } else {
                setCartData({ items: [], total: 0 });
            }
        } catch (err) {
            console.error("Cart load error:", err);
        }

        setLoading(false);
    };

    useEffect(() => {
        loadCart();
    }, []);

    const updateCart = async (productId, qty) => {
        if (!sessionId) return;

        setUpdating(productId);

        try {
            if (qty <= 0) {
                await Handler({
                    method: "delete",
                    url: `/cart/remove.php`,
                    data: { session_id: sessionId, product_id: productId }
                });
            } else {
                await Handler({
                    method: "post",
                    url: `/cart/add.php`,
                    data: {
                        session_id: sessionId,
                        products: [{ product_id: productId, qty }]
                    }
                });
            }

            loadCart();
        } catch (err) {
            console.error("Update error:", err);
        }

        setUpdating(null);
    };

    // -----------------------------
    // SUBMIT ORDER
    // -----------------------------
    const submitOrder = async () => {
        if (!sessionId) {
            toast.error("Session missing");
            return;
        }

        // OUTDOOR requires address
        if (orderType === "outdoor") {

            if (!doorNo || doorNo.trim().length < 1) {
                toast.error("Please enter valid Door No");
                return;
            }

            if (!address || address.trim().length < 5) {
                toast.error("Please enter a proper Address (min 5 characters)");
                return;
            }

            if (!pincode || pincode.trim().length !== 6) {
                toast.error("Please enter valid 6-digit Pincode");
                return;
            }

            if (!city || city.trim().length < 3) {
                toast.error("Please enter valid City name");
                return;
            }

            if (!district || district.trim().length < 3) {
                toast.error("Please enter valid District name");
                return;
            }
        }

        const fullAddress =
            orderType === "indoor"
                ? "" // indoor does not send address
                : `${doorNo}, ${address}, ${city}, ${district} - ${pincode}`;

        try {
            const response = await Handler({
                method: "post",
                url: `/order/checkout.php`,
                data: {
                    qr_slug: slug, // update dynamically
                    session_id: sessionId,
                    payment_method: "COD",
                    order_type: orderType,
                    delivery_address: fullAddress
                }
            });
            if (response.success) {
                toast.success("Order placed successfully!");
                setCheckoutOpen(false)
                reloadWindowToPath('/products')
            } else {
                toast.error(response.msg);
            }
        } catch (err) {
            toast.error("Something went wrong");
        }
    };

    return (
        <div className="cart-page-wrapper">
            <Container>

                <h2 className="cart-title">Your Cart</h2>

                {loading ? (
                    <div className="cart-loader">
                        <Spinner color="primary" />
                    </div>
                ) : cartData.items.length === 0 ? (
                    <div className="empty-cart text-center">
                        <img className="cart-img" src={CartImg} alt="empty" />
                        <h4 className="mt-3">Your cart is empty</h4>
                        <p className="text-muted mt-2">
                            Looks like you haven’t added anything yet
                        </p>

                        <Button
                            color="primary"
                            size="lg"
                            className="mt-3"
                            onClick={() => navigate("/products")}
                        >
                            Browse Products
                        </Button>

                    </div>

                ) : (
                    <>
                        <Row className="cart-items-row">
                            {cartData.items.map((item) => (
                                <>

                                    <Col xs="12" className="cart-item-card" key={item.product_id}>
                                        <div className="cart-item">

                                            <div className="d-md-flex align-items-center gap-4 ">
                                                <div className="cart-item-img-box">
                                                    <img src={item.image || "https://via.placeholder.com/100"} alt={item.name} />
                                                </div>

                                                <div className="cart-item-details mt-3 mt-md-0">
                                                    <h5>{item.name}</h5>
                                                    <p className="price-text">₹ {item.price}</p>
                                                </div>
                                            </div>

                                            <div className="cart-qty-box">
                                                <button
                                                    className="qty-btn"
                                                    disabled={(updating === item.product_id) || (item.qty === 1)}
                                                    onClick={() => updateCart(item.product_id, item.qty - 1)}
                                                >
                                                    <i className='bx bx-minus'></i>
                                                </button>

                                                <span className="qty-display">
                                                    {updating === item.product_id ? "…" : item.qty}
                                                </span>

                                                <button
                                                    className="qty-btn"
                                                    disabled={updating === item.product_id}
                                                    onClick={() => updateCart(item.product_id, item.qty + 1)}
                                                >
                                                    <i className='bx bx-plus'></i>
                                                </button>
                                                <div className="cart-remove-box">
                                                    <button
                                                        className="remove-btn"
                                                        disabled={updating === item.product_id}
                                                        onClick={() => updateCart(item.product_id, 0)}
                                                    >
                                                        <i className='bx bx-trash'></i>
                                                    </button>
                                                </div>
                                            </div>



                                        </div>
                                    </Col></>
                            ))}
                        </Row>

                        <div className="cart-summary">
                            <div>
                                <h4>Total: ₹ {cartData.total}</h4>
                                <small>{cartData.items.length} items</small>
                            </div>

                            <div className="cart-summary-buttons">
                                <Button outline color="dark" onClick={() => navigate("/products")}>
                                    Continue Shopping
                                </Button>

                                <Button color="success" onClick={toggleCheckout}>
                                    Checkout
                                </Button>
                            </div>
                        </div>
                    </>
                )}

                {/* CHECKOUT MODAL */}
                <Modal isOpen={checkoutOpen} toggle={toggleCheckout} centered>
                    <ModalHeader toggle={toggleCheckout}>Order Type</ModalHeader>
                    <ModalBody>

                        {/* Indoor / Outdoor Selection */}
                        <Label>Choose Order Type</Label>
                        <Input
                            type="select"
                            value={orderType}
                            onChange={(e) => setOrderType(e.target.value)}
                        >
                            <option value="indoor">Indoor</option>
                            <option value="outdoor">Outdoor (Delivery)</option>
                        </Input>

                        {/* Show address fields ONLY for outdoor */}
                        {orderType === "outdoor" && (
                            <>
                                <Label className="mt-3">Door No</Label>
                                <Input value={doorNo} onChange={(e) => setDoorNo(e.target.value)} />

                                <Label className="mt-3">Address</Label>
                                <Input value={address} onChange={(e) => setAddress(e.target.value)} />

                                <Label className="mt-3">Pincode</Label>
                                <Input value={pincode} onChange={(e) => setPincode(e.target.value)} />

                                <Row className="mt-3">
                                    <Col md="6">
                                        <Label>City</Label>
                                        <Input value={city} onChange={(e) => setCity(e.target.value)} />
                                    </Col>
                                    <Col md="6">
                                        <Label>District</Label>
                                        <Input value={district} onChange={(e) => setDistrict(e.target.value)} />
                                    </Col>
                                </Row>
                            </>
                        )}

                    </ModalBody>

                    <ModalFooter>
                        <Button color="secondary" onClick={toggleCheckout}>Cancel</Button>
                        <Button color="success" onClick={submitOrder}>Submit Order</Button>
                    </ModalFooter>
                </Modal>

            </Container>
        </div>
    );
};

export default Cart;
